import React from "react";

import { BoostProps } from "./Boost.types";

import "./Boost.scss";

const Boost: React.FC<BoostProps> = ({ value }) => (
  <div data-testid="Boost" className="mp-templates-boost--main">
    {value}
  </div>
);

export default Boost;
